export interface FormValues {
	optOut: boolean;
	SendDocumentsByPost: boolean;
	confirm: boolean;
	voluntaryExcess: string;
	levelOfCover: string;
}

export const initialFormValues: FormValues = {
	optOut: false,
	SendDocumentsByPost: false,
	confirm: false,
	voluntaryExcess: '',
	levelOfCover: '',
};
